export const THEME_OPTIONS = [
  {
    id: "light",
    label: "Light mode",
    shortLabel: "Light",
    description: "Crisp, neutral, and bright.",
    isDark: false,
    previewColors: ["#f8fafc", "#ffffff", "#172033"],
  },
  {
    id: "dark",
    label: "Dark mode",
    shortLabel: "Dark",
    description: "Calm graphite with gentle contrast.",
    isDark: true,
    previewColors: ["#17191d", "#202329", "#f1f5f9"],
  },
  {
    id: "midnight",
    label: "Midnight",
    shortLabel: "Midnight",
    description: "Deep indigo slate with focused violet.",
    isDark: true,
    previewColors: ["#0e0f17", "#181923", "#675ce1"],
  },
] as const;

export type Theme = (typeof THEME_OPTIONS)[number]["id"];

const themeIds = new Set<string>(THEME_OPTIONS.map(({ id }) => id));
const darkThemeIds = new Set<Theme>(
  THEME_OPTIONS.filter(({ isDark }) => isDark).map(({ id }) => id),
);

export function isTheme(value: string | null): value is Theme {
  return value !== null && themeIds.has(value);
}

export function isDarkTheme(theme: Theme) {
  return darkThemeIds.has(theme);
}
